module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmBAMAAABaE/SdAAAAFVBMVEVHcEz///////////////////////+3ygHaAAAABnRSTlMAzxBgnzDNLUJdAAAAvElEQVQoz23STQrCMBAF4MGpF6jiWsEDCEIvIOQE4r4Ic/8jmEx+Ou/VQjfJ107mTUTuV4HnKXK4zLCk9pCbrQAX++bXZmC2ymQAK0kRahUA+58C1L4f4FZwQN12B4znalBjtQbx+A4VT++QuizwZJRGhkbMIbEKiZWiu7Vl/63+qZHZmaC3kBB6CziZ1inA1mmEI5AARyAbDLkNGHLrEOJtEOKtkKbgkKZQoHwoopTv5JESmvLdlTdN4SU/fE5QpQ+CAxMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 0